(function () {
  if (window.__giftWrapBound) return;
  window.__giftWrapBound = true;

  const routes = window.theme?.routes || {};
  let busy = false;

  function getCartItems() {
    return document.querySelector('cart-items');
  }

  function waitForCartChange() {
    return new Promise((resolve) => {
      const finish = () => {
        clearTimeout(timer);
        document.removeEventListener('theme:cart:change', finish);
        resolve();
      };
      const timer = setTimeout(finish, 4000);
      document.addEventListener('theme:cart:change', finish);
    });
  }

  async function updateAttributes(attributes) {
    const url = routes.cart_update_url || '/cart/update.js';
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) throw new Error(`Cart attribute update failed: ${response.status}`);
    return response.json();
  }

  function findGiftWrapItem(variantId, title) {
    const byVariant = document.querySelector(`[data-item][data-variant-id="${variantId}"]`);
    if (byVariant) return byVariant;

    if (!title) return null;
    return document.querySelector(`[data-item-title="${CSS.escape(title)}"]`);
  }

  function reloadCart(cartItems) {
    if (typeof cartItems?.getCart === 'function') {
      cartItems.getCart();
      return;
    }

    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function applyToggleVisual(checkbox, isChecked) {
    checkbox.checked = isChecked;

    const root = checkbox.closest('.cart__widget--gift-note') || checkbox.closest('.cart__widget') || document;
    const fields = root.querySelector('[data-gift-note-fields]');
    if (fields) fields.hidden = !isChecked;
  }

  function setToggleBusy(checkbox, isBusy) {
    const root = checkbox.closest('.cart__widget--gift-note');
    if (root) root.classList.toggle('is-busy', isBusy);
    checkbox.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function syncToggles(variantId, title, forceChecked) {
    const inCart = forceChecked !== undefined ? forceChecked : Boolean(findGiftWrapItem(variantId, title));

    document.querySelectorAll('[data-gift-wrap-toggle]').forEach((toggle) => {
      const toggleVariantId = Number(toggle.getAttribute('data-gift-wrap-variant-id'));
      if (variantId && toggleVariantId && toggleVariantId !== variantId) return;

      applyToggleVisual(toggle, inCart);
    });
  }

  document.addEventListener('change', async (event) => {
    const el = event.target;
    if (!el?.matches('[data-gift-wrap-toggle]')) return;
    if (busy) return;

    // Capture intent BEFORE any cart code runs. Mobile Safari can revert
    // `checked` if the input is disabled during/after the change event.
    const shouldEnable = el.checked;
    const variantId = Number(el.getAttribute('data-gift-wrap-variant-id'));
    const attrName = el.getAttribute('data-gift-wrap-attr-name') || 'Gift wrap';
    const title = el.getAttribute('data-gift-wrap-title') || '';

    applyToggleVisual(el, shouldEnable);

    if (!variantId) return;

    busy = true;
    setToggleBusy(el, true);

    // Re-assert the user's choice in case Safari already flipped it back
    applyToggleVisual(el, shouldEnable);

    const cartItems = getCartItems();

    try {
      if (shouldEnable) {
        await updateAttributes({ [attrName]: 'Yes' });

        const cartReloaded = waitForCartChange();

        if (typeof cartItems?.addToCart === 'function') {
          cartItems.addToCart([{ id: variantId, quantity: 1 }], null);
        } else {
          reloadCart(cartItems);
        }

        await cartReloaded;
        syncToggles(variantId, title, Boolean(findGiftWrapItem(variantId, title)));
      } else {
        await updateAttributes({ [attrName]: '' });

        const item = findGiftWrapItem(variantId, title);
        const cartReloaded = waitForCartChange();

        if (item && typeof cartItems?.updateCart === 'function') {
          cartItems.updateCart(
            {
              id: item.getAttribute('data-item'),
              quantity: 0,
            },
            item
          );
        } else {
          reloadCart(cartItems);
        }

        await cartReloaded;
        syncToggles(variantId, title, Boolean(findGiftWrapItem(variantId, title)));
      }
    } catch (error) {
      console.error('[Gift wrap] error:', error);
      syncToggles(variantId, title, !shouldEnable);
    } finally {
      busy = false;
      setToggleBusy(el, false);
      // Cart disable/enable can flip the checkbox on iOS — sync once more next frame
      requestAnimationFrame(() => {
        syncToggles(variantId, title);
      });
    }
  });
})();
